import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/components/Marker/NumCircle.styled.ts",
    _templateObject2,
    _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
export var NumCircleRoot = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(0, 5, 15, 0.22);\n  border-radius: 4px;\n  padding: 1px 4px 0 4px;\n  font-size: 11px;\n  line-height: 13px;\n  color: rgba(0, 5, 15, 0.22);\n  font-weight: bold;\n  ", "\n"])), function (_ref) {
  var disabled = _ref.disabled;
  return !disabled && "&:hover {background: rgba(199, 200, 202, 1); border: 1px solid rgba(199, 200, 202, 1); }";
});
export var TitleText = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 20px;\n"])));
export var DependencyText = styled(TitleText)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: #f5a623;\n"])));